
// Function to send email via your Lambda API
export const sendEmailAPI = async (resource, to, subject, html) => {
  const apiUrl = `${process.env.REACT_APP_EMAIL_AWS_API}/${resource}`;
  
  const requestBody = {
    to: to,
    subject: subject,
    html: html,
  };

  console.log(requestBody)
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    if (response.ok) 
      {
      return {...data, success: true};
    } else {
      throw new Error(data.message || "Failed to send email");
    }
  } catch (error) {
  }
};
